<template>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button class="button_back" @click="goBack">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title v-if="job.startDate">
      <template v-if="checkJobDateStart(job.startDate, job.endDate)">
        <span>{{ checkJobDateStart(job.startDate, job.endDate, true) }}</span> -
      </template>
      <span v-if="isUS">{{
          $moment(job.endDate, ["YYYY/MM/DD", "YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss.SSSZ", "DD MMM YYYY"]).format("MMM DD YYYY")
          }}</span>
      <span v-else>{{
          $moment(job.endDate, ["YYYY/MM/DD", "YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss.SSSZ", "DD MMM YYYY"]).format("DD MMMM YYYY")
          }}</span>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button class="button_more" @click="bottomDropUp = true" data-testid="button-more">
        <ion-icon name="ellipsis-vertical-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="main_wrapper ion-padding">
    <div class="container">
      <el-alert
        v-if="job.pending_documents"
        title="Acknowledgment pending — complete required onboarding documents before accepting shifts"
        type="warning"
        :closable="false"
        show-icon
        class="mb-3"
      ></el-alert>
      <div class="job_info_wrapper" v-if="job.pharmacy">
        <div class="image_text_comp d-block" @click="userInfoModalOpen()">
          <div class="image_wrapper">
            <el-avatar :size="'medium'" shape="square" :src="job.pharmacy.image" v-if="job.pharmacy.image" />
            <el-avatar :size="'medium'" shape="square" icon="el-icon-user-solid" v-else></el-avatar>
          </div>
          <div class="text_wrapper mt-2">
            <div class="main_text">{{ job.pharmacy.name }}</div>
            <div class="additional_text">
              <span class="distance">
                <span v-if="job.distance">{{ distanceInMiles(job.distance,'km',true) }} away</span>
                <span class="symb_infinity" v-else></span>
              </span>
            </div>
          </div>
        </div>

        <div class="info-separator" />
        
        <div class="rate_shifts_info">
          <div class="info_wrapper d-flex align-items-center">
            <ClockIcon />
            <div class="info_title">Available Shifts 
              <template v-if="checkJobDateStart(job.startDate, job.endDate)">
                <span>{{ checkJobDateStart(job.startDate, job.endDate, true) }}</span> -
              </template>
              <span v-if="isUS">{{
                  $moment(job.endDate, ["YYYY/MM/DD", "YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss.SSSZ", "DD MMM YYYY"]).format("MMM DD YYYY")
                  }}</span>
              <span v-else>{{
                  $moment(job.endDate, ["YYYY/MM/DD", "YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss.SSSZ", "DD MMM YYYY"]).format("DD MMMM YYYY")
                  }}</span>
            </div>
          </div>
          <div class="info_wrapper d-flex align-items-center">
            <LocationIcon />
            <div class="info_title">{{ $filters.addressText(job.pharmacy.address) }}</div>
          </div>
          <div class="info_wrapper d-flex align-items-center" v-if="!job.isInternalStaffOfThisPharmacy && job.isVisibileAsInternalLocum === false">
            <DollarWithCircleIcon />
            <div class="info_title">Hourly Rate <span v-if="isAustralia">(excluding super)</span></div>
            <div class="info_value">
              {{
                formatHourlyRate(job.recommendedRate, job.recommendedWeekendRate)
              }}
            </div>
          </div>
        
        </div>

        <div class="clr-danger" v-if="!userData.locumVerifiedCvExist && job.applyJob && userData.role !== 'agency'">
          Please upload your CV to apply for this job
        </div>
        <div class="info-separator-without-border mb-0" />
        <el-collapse accordion class="job-about-collapse" @change="handleChange">
          <el-collapse-item class="card-accordeon" title="More about the job" name="first">
            <div class="collapse-list more-info">
              <div class="nested-collapse-wrapper" v-if="shouldDisplay">
                <el-collapse accordion="true" v-model="activeNames">
                  <el-collapse-item class="card-accordeon card-accordeon--nested" title="Script Numbers, Software and Services" name="1">
                    <div class="collapse-list more-info">
                      <div class="collapse-item" v-if="job.pharmacy.environment.scriptsPerDay">
                        <span class="collapse-title">Average scripts per day (weekdays)</span>
                        <span class="collapse-value">
                          {{ getScriptName(job.pharmacy.environment.scriptsPerDay) }}
                        </span>
                      </div>
                      <div class="collapse-item" v-if="job.pharmacy.averageScriptsSaturdayId">
                        <span class="collapse-title">Average scripts on Saturday</span>
                        <span class="collapse-value">
                          {{ getScriptName(job.pharmacy.averageScriptsSaturdayId) }}
                        </span>
                      </div>
                      <div class="collapse-item" v-if="job.pharmacy.averageScriptsSundayId">
                        <span class="collapse-title">Average scripts on Sunday</span>
                        <span class="collapse-value">
                          {{ getScriptName(job.pharmacy.averageScriptsSundayId) }}
                        </span>
                      </div>
                      <div class="collapse-item" v-if="job.pharmacy.environment.software">
                        <span class="collapse-title">Dispensing software</span>
                        <span class="collapse-value" v-if="getSoftwareName(job.pharmacy.environment.software) === 'Other'">
                          {{ getSoftwareName(job.pharmacy.environment.software) }}:
                          {{ job.pharmacy.settings.softwareOther }}
                        </span>
                        <span class="collapse-value" v-else>
                          {{ getSoftwareName(job.pharmacy.environment.software) }}
                        </span>
                      </div>
                      <div class="collapse-item collapse-item--services" v-if="job.pharmacy.environment.services">
                        <span class="collapse-title">Services</span>
                        <span class="collapse-value">
                          <el-tag class="white" v-for="service in job.pharmacy.environment.services" :key="service">
                            {{ service.name }}
                          </el-tag>
                        </span>
                      </div>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
              <div class="collapse-item" v-if="!job.isInternalStaffOfThisPharmacy && job.isVisibileAsInternalLocum === false">
                <span class="collapse-title">Hourly Rate <span v-if="isAustralia">(excluding super)</span></span>
                <span class="collapse-value">
                  {{
                    formatHourlyRate(
                      job.recommendedRate,
                      job.recommendedWeekendRate
                    )
                  }}
                </span>
              </div>

              <div v-if="job.settings.languages" class="collapse-item">
                <span class="collapse-title">Language</span>
                <span class="collapse-value">
                  {{ job.settings.languageNames }}
                </span>
              </div>

              <div class="collapse-item">
                <span class="collapse-title">Solo Pharmacist</span>
                <span class="collapse-value">{{
                  job.settings.solo == 1 ? "Yes" : "No"
                }}</span>
              </div>

              <div class="collapse-item" v-if="userData.platformRoleSlug == 'pharmacist' || userData.platformRoleSlug == 'dispense-technician' || userData.platformRoleSlug == 'intern-pharmacist' || userData.platformRoleSlug == 'retail-staff'">
                <span class="collapse-title">{{ message.Immuniser }} req?</span>
                <span class="collapse-value">{{
                  job.covidCertRequired == 0
                  ? "Not Required"
                  : job.covidCertRequired == 1
                    ? "Mandatory"
                    : "Nice to Have"
                }}</span>
              </div>

              <div class="collapse-item" v-if="userData.platformRoleSlug == 'pharmacist' || userData.platformRoleSlug == 'dispense-technician' || userData.platformRoleSlug == 'intern-pharmacist' || userData.platformRoleSlug == 'retail-staff'">
                <span class="collapse-title">Number of technicians</span>
                <span class="collapse-value">{{ job.settings.numOfTech }}</span>
              </div>
              <template v-if="!job.isInternalStaffOfThisPharmacy && job.isVisibileAsInternalLocum === false">
                <div class="collapse-item" v-if="job.settings.payingForTravel == 3 && job.maxTravelCompensation !== 0">
                  <span class="collapse-title">Pay for Travel</span>
                  <span class="collapse-value">{{ job.enableTravelAllowanceForFirstAndLastDay === 1 ? "Pay for first and last day of shift" : "Capped Travel" }}</span>
                </div>
                <div class="collapse-item" v-else>
                  <span class="collapse-title">Pay for Travel {{
                    job.settings.payingForTravel == 1 ? " (>50KM roundtrip)" : ""
                  }}</span>
                  <span class="collapse-value">{{
                      job.enableTravelAllowanceForFirstAndLastDay === 1
                        ? "Pay for first and last day of shift"
                        : job.settings.payingForTravel === 0
                          ? "No travel"
                          : job.settings.payingForTravel === 1
                            ? "Partial travel"
                            : "Full travel"
                    }}</span>
                </div>
              </template>

              <div class="collapse-item">
                <span class="collapse-title">Pay for Flights</span>
                <span class="collapse-value">{{
                  job.settings.payForFlights == 0 ? "No" : "Yes"
                }}</span>
              </div>
              <div class="collapse-item">
                <span class="collapse-title">Pay for Accommodation</span>
                <span class="collapse-value">{{
                  job.settings.payForAccommodation == 0 ? "No" : "Yes"
                }}</span>
              </div>
              <div class="collapse-item"  v-if="
                  isAustralia &&
                  (
                    userData.platformRoleSlug === 'pharmacist' ||
                    userData.platformRoleSlug === 'dispense-technician' ||
                    userData.platformRoleSlug === 'intern-pharmacist' ||
                    userData.platformRoleSlug === 'retail-staff'
                  )
                ">
                <span class="collapse-title">Dosage Administration Aids</span>
                <span class="collapse-value">{{
                  job.settings.adminAids == 1 ? "Yes" : "No"
                }}</span>
              </div>
              <div class="collapse-item" v-if="userData.platformRoleSlug == 'pharmacist' || userData.platformRoleSlug == 'dispense-technician' || userData.platformRoleSlug == 'intern-pharmacist' || userData.platformRoleSlug == 'retail-staff'">
                <span class="collapse-title">Open Pharmacy</span>
                <span class="collapse-value">{{
                  job.settings.openUp == 1 ? "Yes" : "No"
                }}</span>
              </div>
              <div class="collapse-item" v-if="userData.platformRoleSlug == 'pharmacist' || userData.platformRoleSlug == 'dispense-technician' || userData.platformRoleSlug == 'intern-pharmacist' || userData.platformRoleSlug == 'retail-staff'">
                <span class="collapse-title">Close Pharmacy</span>
                <span class="collapse-value">{{
                  job.settings.close == 1 ? "Yes" : "No"
                }}</span>
              </div>
              <div v-if="job.settings.notes" class="collapse-item collapse-item--notes">
                <span class="collapse-title">Notes</span>
                <p class="job-notes__content">{{ job.settings.notes }}</p>
              </div>
              <div v-if="job.settings.parking" class="collapse-item collapse-item--notes">
                <span class="collapse-title">Parking</span>
                <p class="job-notes__content">{{ job.settings.parking }}</p>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
        <div class="info-separator-without-border mt-0" />
      </div>
      <div></div>
      <el-form class="job_shifts_wrapper full_page" :model="formsData.dayForm" :rules="formsData.dayForm.rules"
        :ref="(el) => (formsData.dayForm.ref = el)" :label-position="'top'" @submit.prevent="submit('dayForm')">
        <div class="d-flex justify-content-between mb-4 align-items-center" >
          <div class="text-locumate-secondary fs-18 font-weight-600">Shifts</div>
          <el-button type="primary" round size="sm" @click="SelectAllShifts" v-if="formsData.dayForm.jobShifts.value.length > 1">
            {{ buttonLabel }}
          </el-button>
        </div>
        <!-- Display message if no shifts are available -->
        <div v-if="formsData.dayForm.jobShifts.value.length === 0" class="no-shifts-message">
          This shift has already been accepted by another locum. Check out other available shifts!
          <div class="d-flex justify-center size-button-home">
            <el-button class="el-button " type="blue" @click="goBack">
                Home
              </el-button>
          </div>
          
        </div>
        <template v-else>
          <div v-if="job.isBlockShift == 1 && formsData.dayForm.jobShifts.value.length >= 2">
            <div class="form_text">
              <div class="text_note">Important: This is a bulk shift. The professional requests a single locum to book all listed shifts. Individual shift bookings are not available.</div>
            </div>
          </div>
          <div v-else-if="job.isBlockShift == 1 && formsData.dayForm.jobShifts.value.length <= 1">
          </div>
          <div class="job_shifts_form_checkbox" v-for="(shift, i) in formsData.dayForm.jobShifts.value" :key="shift.date">
            <el-form-item class="mb0" prop="jobShifts" v-if="shift.totalShiftApplications < job.maximumApplicationLimit && shift.abilities.assign == true">
              <el-checkbox :disabled="shift.disabled" class="checkbox_w100" v-model="shift.checkboxValue"
                @change="checkboxValueChange(shift.checkboxValue)">
                <div :class="shift.confirmedHours ? 'confirmedHours' : ''" class="job_shift_text">
                  <div class="day_info">
                    <div class="day_name" v-if="isAustralia">
                      {{ $moment(shift.date, ["YYYY/MM/DD", "YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss.SSSZ", "DD MMM YYYY"]).format("ddd") }},
                      {{ $moment(shift.date, ["YYYY/MM/DD", "YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss.SSSZ", "DD MMM YYYY"]).format("DD MMM, YYYY") }}
                    </div>
                    <div class="day_name" v-else>
                      {{ $moment(shift.date, ["YYYY/MM/DD", "YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss.SSSZ", "DD MMM YYYY"]).format("dddd") }},
                      {{ $moment(shift.date, ["YYYY/MM/DD", "YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss.SSSZ", "DD MMM YYYY"]).format("MMM DD YYYY") }}
                      </div>
                    <div class="day_time">
                      <span>{{
                        $moment(shift.startTime, "HH:mm").format("h:mm A")
                      }}</span>
                      -
                      <span>{{
                        $moment(shift.endTime, "HH:mm").format("h:mm A")
                      }}</span>
                      <span v-if="showShiftInformation(shift)">
                          ({{
                            confirmedHours(
                              shift.confirmedHours,
                              shift.startTime,
                              shift.endTime
                            )
                          }} Hours)</span>
                    </div>
                  </div>
                  <div class="info-wrapper">
                    <div class="day_info_block"
                      v-if="!job.isInternalStaffOfThisPharmacy && shift.isVisibileAsInternalLocum === false">
                      <DollarWithCircleIcon />
                      <div class="day_name">Hourly Rate</div>
                      <div class="day_time">
                        <span v-if="showShiftInformation(shift)">
                          {{ Rate(shift) }}</span>
                        <span v-else>-</span>
                      </div>
                    </div>
                    <div class="day_info_block"
                      v-if="!job.isInternalStaffOfThisPharmacy && shift.isVisibileAsInternalLocum === false">
                      <RoutingIcon />
                      <div class="title" v-if="job.settings.payingForTravel == 3 && job.maxTravelCompensation !== 0">
                        <span > {{ job.enableTravelAllowanceForFirstAndLastDay === 1 ? "Travel" : "Capped Travel" }}</span>
                      </div>
                      <div class="title" v-else>
                        <span>Travel</span>
                      </div>
                      <div class="day_time">
                        <span v-if="showShiftInformation(shift)">
                          <span v-if="userData.isInternalStaffOfThisPharmacy">-</span>
                          <span v-else>{{ travelCompensationCount(job, shift, i) }}</span>
                        </span>
                        <span v-else>-</span>
                      </div>
                    </div>
                    <template v-if="isAustralia">
                      <div class="day_info_block"
                      v-if="!job.isInternalStaffOfThisPharmacy && shift.isVisibileAsInternalLocum === false">
                      <DollarWithCircleIcon />
                        <div class="day_name">Total Super</div>
                          <div class="day_time">
                            <span v-if="showShiftInformation(shift)">
                              {{ superRate(shift) }}
                            </span>
                            <span v-else>-</span>
                          </div>
                      </div>
                    </template>
          
                    <div class="day_info_block"
                      v-if="!job.isInternalStaffOfThisPharmacy && shift.isVisibileAsInternalLocum === false">
                      <DollarWithCircleIcon />
                      <div class="day_name">Sum</div>
                      <div class="day_time">
                        <span v-if="showShiftInformation(shift)">
                          {{ Sum(job, shift , i) }}</span>
                        <span v-else>-</span>
                      </div>
                    </div>
          
                  </div>
                </div>
              </el-checkbox>
              <template #error="{ error }">
                <div class="error_list" v-if="error ||
                  (formsData.dayForm.jobShifts.errors &&
                    formsData.dayForm.jobShifts.errors[i])
                  ">
                  <div class="el-form-item__error" :class="formsData.dayForm.jobShifts.errors &&
                      formsData.dayForm.jobShifts.errors[i]
                      ? ''
                      : 'form_error'
                    ">
                    <span v-if="error && job.isBlockShift !== 1 &&
                      !formsData.dayForm.jobShifts.errors &&
                      formsData.dayForm.jobShifts.value.length - 1 == i
                      ">{{ error }}</span>
                    <span v-if="error && job.isBlockShift == 1 &&
                      !formsData.dayForm.jobShifts.errors &&
                      formsData.dayForm.jobShifts.value.length - 1 == i
                      ">Please select all days</span>
                    <span v-if="formsData.dayForm.jobShifts.errors &&
                      formsData.dayForm.jobShifts.errors[i]
                      ">{{ formsData.dayForm.jobShifts.errors[i].message }}</span>
                  </div>
                </div>
                <span v-else></span>
              </template>
            </el-form-item>
          </div>
          <div v-if="userData.role !== 'pharmacy'">
            <!-- Pending documents checklist on main page if pending documents exist -->
            <div class="pending-documents-card mb-3" v-if="pendingDocumentList && pendingDocumentList.length > 0">
              <div class="pending-documents-header">
                <div class="pending-documents-title">
                  <i class="el-icon-document-checked mr-1"></i> Required Onboarding Documents
                </div>
                <div class="pending-documents-subtitle">
                  Please click each document to review and acknowledge before proceeding.
                </div>
              </div>
              <div class="pending-documents-list">
                <div 
                  v-for="(doc, index) in pendingDocumentList" 
                  :key="doc.id || index"
                  class="pending-doc-item"
                  :class="{ 'is-acknowledged': doc.acknowledged, 'is-required': doc.required }"
                  @click="handleDocItemClick(doc)"
                >
                  <div class="pending-doc-checkbox-wrapper">
                    <el-checkbox 
                      :model-value="doc.acknowledged" 
                      :disabled="doc.acknowledged"
                      @change="handleDocItemClick(doc)"
                      @click.stop
                    ></el-checkbox>
                  </div>
                  <div class="pending-doc-info">
                    <div class="pending-doc-name-row">
                      <span class="pending-doc-name">{{ doc.name }}</span>
                      <span v-if="doc.required" class="doc-badge-required">Required</span>
                      <span v-if="doc.acknowledged" class="doc-badge-accepted">
                        <i class="el-icon-check"></i> Accepted
                      </span>
                    </div>
                    <div class="pending-doc-action-row">
                      <span class="doc-action-hint" v-if="!doc.acknowledged">
                        <i class="el-icon-edit-outline"></i> Click to review & accept
                      </span>
                      <a 
                        v-if="doc.url" 
                        :href="doc.url" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        class="doc-preview-link"
                        @click.stop
                      >
                        <i class="el-icon-view"></i> View Document <i class="el-icon-top-right"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <el-form-item prop="jobShiftsErrors" class="button_submit mb0" v-if="job.shiftApplicationType != 0 ">
              <el-button class="submit_page" type="grey" @click="goNext('dayForm')">
                Calendar View
              </el-button>
              <template v-if="userData.role === 'agency'">
                <el-button class="submit_page" type="blue" @click="bottomDropUpAcceptShift = true" :disabled="formsData.dayForm.disabled">
                  Mark as Filled
                </el-button>
              </template>
              <template v-else>
                <el-button class="submit_page" type="blue" @click="openAcceptShiftDrawer"
                  :disabled="formsData.dayForm.disabled || isButtonDisabled || !userData.locumVerifiedCvExist || !areAllRequiredDocsAccepted"
                  v-if="job.applyJob">
                  Apply now
                </el-button>
                <el-button class="submit_page" type="blue" @click="openAcceptShiftDrawer"
                  :disabled="formsData.dayForm.disabled || isButtonDisabled || !areAllRequiredDocsAccepted" v-else>
                  Accept now
                </el-button>
              </template>
            </el-form-item>
            <el-form-item prop="jobShiftsErrors" class="button_submit mb0" v-else>
              <el-button class="submit_page" type="grey" @click="goNext('dayForm')">
                Calendar View
              </el-button>
              <template v-if="userData.role === 'agency'">
                <el-button class="submit_page" type="blue" @click="bottomDropUpAcceptShift = true" :disabled="formsData.dayForm.disabled">
                  Mark as Filled
                </el-button>
              </template>
              <template v-else>
                <el-button class="submit_page" type="blue" @click="openAcceptShiftDrawer"
                  :disabled="formsData.dayForm.disabled || isButtonDisabled || !userData.locumVerifiedCvExist || !areAllRequiredDocsAccepted"
                  v-if="job.applyJob">
                  Apply now
                </el-button>
                <el-button class="submit_page" type="blue" @click="openAcceptShiftDrawer"
                  :disabled="formsData.dayForm.disabled || isButtonDisabled || !areAllRequiredDocsAccepted" v-else>
                  Accept now
                </el-button>
              </template>
            </el-form-item>
          </div>
        </template>
      </el-form>
    </div>
  </div>

  <el-drawer custom-class="bottom_drop_up accept_shift" v-model="bottomDropUpAcceptShift" :append-to-body="true" :with-header="false"
  :direction="'btt'" :destroy-on-close="true" data-testid="more-bottom-drop-up-drawer">
  <div class="title-wrapper text-center">
    <div class="title text-locumate-secondary">Are you sure!</div>
    <p class="message">
      {{ job.applyJob ? 'You will be notified of the outcome of your application once it has been reviewed. In the meantime, you can continue to apply for shifts on the same date.' : 'Please ensure you have checked your availability for selected shift(s). Any cancellations will impact your reliability rating on the platform.' }}
    </p>
  </div>
    
    <div class="job_shifts_form_checkbox" v-for="(shift,i) in formsData.dayForm.jobShifts.value" :key="shift.date">
      <div class="job_shifts_wrapper full_page" v-if="shift.checkboxValue == true && shift.abilities.assign == true">
        <div class="mb0 shift-check" prop="jobShifts">
          <div :class="shift.confirmedHours ? 'confirmedHours' : ''" class="job_shift_text">
            <div class="check-icon"><i class="el-icon-check"></i></div>
            <div class="day_info">
              <div class="day_name shift_date" v-if="isAustralia">
                {{ $moment(shift.date, ["YYYY/MM/DD", "YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss.SSSZ", "DD MMM YYYY"]).format("ddd") }},
                {{
                  $moment(shift.date, ["YYYY/MM/DD", "YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss.SSSZ", "DD MMM YYYY"]).format("DD MMM, YYYY")
                }}
              </div>
              <div class="day_name shift_date" v-else>
                {{ $moment(shift.date, ["YYYY/MM/DD", "YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss.SSSZ", "DD MMM YYYY"]).format("dddd") }},
                {{
                  $moment(shift.date, ["YYYY/MM/DD", "YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss.SSSZ", "DD MMM YYYY"]).format("MMM DD YYYY")
                }}
              </div>

             
              <div class="day_time">
                <span>{{
                  $moment(shift.startTime, "HH:mm").format("h:mm A")
                }}</span>
                -
                <span>{{
                  $moment(shift.endTime, "HH:mm").format("h:mm A")
                }}</span>
                <span v-if="showShiftInformation(shift)">
                    ({{
                      confirmedHours(
                        shift.confirmedHours,
                        shift.startTime,
                        shift.endTime
                      )
                    }} Hours)
                    </span>
              </div>
            </div>
            <div class="info-wrapper">
              <div class="day_info_block"
                v-if="!job.isInternalStaffOfThisPharmacy && shift.isVisibileAsInternalLocum === false">
                <DollarWithCircleIcon />
                <div class="day_name">Hourly Rate</div>
                <div class="day_time">
                  <span v-if="showShiftInformation(shift)">
                    {{ Rate(shift) }}</span>
                  <span v-else>-</span>
                </div>
              </div>
              <div class="day_info_block"
                v-if="!job.isInternalStaffOfThisPharmacy && shift.isVisibileAsInternalLocum === false">
                <RoutingIcon />
                <div class="title" v-if="job.settings.payingForTravel == 3 && job.maxTravelCompensation !== 0">
                  <span > {{ job.enableTravelAllowanceForFirstAndLastDay === 1 ? "Travel" : "Capped Travel" }}</span>
                </div>
                <div class="title" v-else>
                  <span>Travel</span>
                </div>
                <div class="day_time">
                  <span v-if="showShiftInformation(shift)">
                    <span v-if="userData.isInternalStaffOfThisPharmacy">-</span>
                    <span v-else>{{ travelCompensationCount(job, shift, i) }}</span>
                  </span>
                  <span v-else>-</span>
                </div>
              </div>
              <template v-if="isAustralia">
                <div class="day_info_block"
                    v-if="!job.isInternalStaffOfThisPharmacy && shift.isVisibileAsInternalLocum === false">
                    <DollarWithCircleIcon />
                      <div class="day_name">Total Super</div>
                        <div class="day_time">
                          <span v-if="showShiftInformation(shift)">
                            {{ superRate(shift) }}
                          </span>
                          <span v-else>-</span>
                        </div>
                  </div>
              </template>
              
              <div class="day_info_block"
                v-if="!job.isInternalStaffOfThisPharmacy && shift.isVisibileAsInternalLocum === false">
                <DollarWithCircleIcon />
                <div class="day_name">Sum</div>
                <div class="day_time">
                  <span v-if="showShiftInformation(shift)">
                    {{ Sum(job, shift , i) }}</span>
                  <span v-else>-</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pending documents inline banner -->
    <transition name="pending-banner-fade">
      <div v-if="pendingDocumentBanner" :class="pendingDocumentBannerSuccess ? 'premium-success-banner' : 'premium-error-banner'">
        <span class="premium-banner__icon">
          <!-- Red error icon if success is false -->
          <svg v-if="!pendingDocumentBannerSuccess" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
            <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-1.72 6.97a.75.75 0 10-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 101.06 1.06L12 13.06l1.72 1.72a.75.75 0 101.06-1.06L13.06 12l1.72-1.72a.75.75 0 10-1.06-1.06L12 10.94l-1.72-1.72z" clip-rule="evenodd" />
          </svg>
          <!-- Green check circle icon if success is true -->
          <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
            <path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.736-5.23z" clip-rule="evenodd" />
          </svg>
        </span>
        <span class="premium-banner__text">{{ pendingDocumentBannerMessage }}</span>
      </div>
    </transition>

    <!-- Pending documents checklist in confirmation drawer -->
    <div class="pending-documents-card" v-if="pendingDocumentList && pendingDocumentList.length > 0">
      <div class="pending-documents-header">
        <div class="pending-documents-title">
          <i class="el-icon-document-checked mr-1"></i> Required Onboarding Documents
        </div>
        <div class="pending-documents-subtitle">
          Please click each document to review and acknowledge before proceeding.
        </div>
      </div>

      <div class="pending-documents-list">
        <div 
          v-for="(doc, index) in pendingDocumentList" 
          :key="doc.id || index"
          class="pending-doc-item"
          :class="{ 'is-acknowledged': doc.acknowledged, 'is-required': doc.required }"
          @click="handleDocItemClick(doc)"
        >
          <div class="pending-doc-checkbox-wrapper">
            <el-checkbox 
              :model-value="doc.acknowledged" 
              :disabled="doc.acknowledged"
              @change="handleDocItemClick(doc)"
              @click.stop
            ></el-checkbox>
          </div>
          <div class="pending-doc-info">
            <div class="pending-doc-name-row">
              <span class="pending-doc-name">{{ doc.name }}</span>
              <span v-if="doc.required" class="doc-badge-required">Required</span>
              <span v-if="doc.acknowledged" class="doc-badge-accepted">
                <i class="el-icon-check"></i> Accepted
              </span>
            </div>
            <div class="pending-doc-action-row">
              <span class="doc-action-hint" v-if="!doc.acknowledged">
                <i class="el-icon-edit-outline"></i> Click to review & accept
              </span>
              <a 
                v-if="doc.url" 
                :href="doc.url" 
                target="_blank" 
                rel="noopener noreferrer" 
                class="doc-preview-link"
                @click.stop
              >
                <i class="el-icon-view"></i> View Document <i class="el-icon-top-right"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="dialog-footer accept-shift-actions-row" v-if="job.shiftApplicationType != 0">
      <el-button class="submit_page btn-half" type="blue" @click="applyShift('dayForm', job.id)"
      :disabled="formsData.dayForm.disabled || isButtonDisabled || !areAllRequiredDocsAccepted" v-if="job.applyJob">
        Apply now
      </el-button>
      <el-button class="submit_page btn-half" type="blue" @click="submit('dayForm')"
      :disabled="formsData.dayForm.disabled || isButtonDisabled || !areAllRequiredDocsAccepted" v-else>
        Accept now
      </el-button>
      <el-button class="btn-half btn-cancel" @click="bottomDropUpAcceptShift = false" type="grey">Cancel</el-button>
    </div>
    <div class="dialog-footer accept-shift-actions-row" v-else>
      <el-button class="submit_page btn-half" type="blue" @click="applyShift('dayForm', job.id)"
      :disabled="formsData.dayForm.disabled || isButtonDisabled || !areAllRequiredDocsAccepted" v-if="job.applyJob">
        Apply now
      </el-button>
      <el-button class="submit_page btn-half" type="blue" @click="submit('dayForm')"
      :disabled="formsData.dayForm.disabled || isButtonDisabled || !areAllRequiredDocsAccepted" v-else>
        Accept now
      </el-button>
      <el-button class="btn-half btn-cancel" @click="bottomDropUpAcceptShift = false" type="grey">Cancel</el-button>
    </div>
  </el-drawer>

  <el-drawer custom-class="bottom_drop_up menu-drawer" v-model="bottomDropUp" :append-to-body="true" :with-header="false"
    :direction="'btt'" :destroy-on-close="true" data-testid="more-bottom-drop-up-drawer">
    <!-- <el-buttons> -->
      <el-button type="transparent" class="d-block menu_item" @click="share(user)" data-testid="share-pharmacy-btn">
        <i class="el-icon-share"></i> Share
      </el-button>
      <el-button type="transparent" class="ml-0 d-block menu_item" @click="blockPharmacy()"
        data-testid="block-unblock-pharmacy-btn">
        <template v-if="job.blockedByLocum">
          <i class="el-icon-unlock mr-1 font-weight-bold"></i> Unblock Pharmacy
        </template>
        <template v-else>
          <i class="locumate_icons locumate_icon-denied mr-1"></i> Block Pharmacy
        </template>
      </el-button>
    <!-- </el-buttons> -->
  </el-drawer>
  <modal-user-info :modalName="'userInfoModal'" :options="userInfoModal"></modal-user-info>

  <!-- Document Review and Acknowledge Dialog Modal -->
  <el-dialog
    v-model="showDocReviewModal"
    :title="'Review & Acknowledge Document'"
    custom-class="doc-review-dialog"
    width="90%"
    :append-to-body="true"
    :close-on-click-modal="false"
    center
  >
    <div class="doc-modal-content" v-if="selectedDocForReview">
      <div class="doc-modal-header-section">
        <div class="doc-modal-title-row">
          <h3 class="doc-modal-doc-title">
            <i class="el-icon-document mr-1"></i> {{ selectedDocForReview.name }}
          </h3>
          <span v-if="selectedDocForReview.required" class="doc-badge-required">Required</span>
          <span v-if="selectedDocForReview.acknowledged" class="doc-badge-accepted">
            <i class="el-icon-check"></i> Accepted
          </span>
        </div>

        <div class="doc-modal-actions-toolbar" v-if="selectedDocForReview.url">
          <a 
            :href="selectedDocForReview.url" 
            target="_blank" 
            rel="noopener noreferrer" 
            class="btn-modal-action btn-open"
          >
            <i class="el-icon-top-right"></i> Open in New Tab
          </a>
          <button 
            type="button" 
            class="btn-modal-action btn-download"
            :disabled="isDownloadingDoc"
            @click="downloadDoc(selectedDocForReview)"
          >
            <i :class="isDownloadingDoc ? 'el-icon-loading' : 'el-icon-download'"></i>
            {{ isDownloadingDoc ? 'Downloading...' : 'Download Document' }}
          </button>
        </div>
      </div>

      <!-- Inline Document Preview Box -->
      <div class="doc-inline-preview-wrapper" v-if="selectedDocForReview.url">
        <!-- Image Preview -->
        <div v-if="isImageDoc(selectedDocForReview.url)" class="doc-preview-container doc-preview-image-box">
          <img 
            :src="selectedDocForReview.url" 
            :alt="selectedDocForReview.name" 
            class="doc-preview-image" 
          />
        </div>

        <!-- PDF / Frame Preview -->
        <div v-else-if="isPdfDoc(selectedDocForReview.url)" class="doc-preview-container doc-preview-frame-box">
          <iframe 
            :src="selectedDocForReview.url" 
            class="doc-preview-iframe"
            frameborder="0"
          ></iframe>
        </div>

        <!-- Other File Types Preview -->
        <div v-else class="doc-preview-container doc-preview-frame-box">
          <iframe 
            :src="selectedDocForReview.url" 
            class="doc-preview-iframe"
            frameborder="0"
          ></iframe>
        </div>
      </div>

      <div class="doc-modal-acknowledgement-box">
        <div class="ack-note">
          <i class="el-icon-info mr-1"></i> By clicking <strong>"I Accept & Acknowledge"</strong>, you confirm that you have read, reviewed, and agreed to the contents of this document.
        </div>
      </div>
    </div>

    <template #footer>
      <div class="dialog-footer flex-footer">
        <el-button @click="showDocReviewModal = false" class="el-button--grey">Cancel</el-button>
        <el-button 
          type="primary" 
          class="el-button--blue"
          :loading="isAcknowledgingDoc"
          :disabled="selectedDocForReview && selectedDocForReview.acknowledged"
          @click="confirmAcknowledgeDoc"
        >
          {{ (selectedDocForReview && selectedDocForReview.acknowledged) ? 'Already Accepted' : 'I Accept & Acknowledge' }}
        </el-button>
      </div>
    </template>
  </el-dialog>
  <MissingProfileRequirementsModal
    v-model="modalVisible"
    :missing="modalMissing"
    :is-apply-job="job.applyJob"
    @complete="goToRequirement"
  />
</template>

<script>
import { ElMessage, ElMessageBox } from "@/components/Vendor/Element";

import moment from "moment";

import { ref, onMounted, onBeforeMount, inject, nextTick, computed } from "vue";

import { addIcons } from "ionicons";
import { arrowBackOutline, ellipsisVerticalOutline } from "ionicons/icons";

addIcons({
  "arrow-back-outline": arrowBackOutline,
  "ellipsis-vertical-outline": ellipsisVerticalOutline
});
import {
  IonToolbar,
  IonButton,
  IonButtons,
  IonIcon,
  IonTitle,
} from "@ionic/vue";

import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import formHooks from "@/hooks/form/form";
import formValidate from "@/hooks/form/validate/validate";

import { UserInfoModal } from "@/modals/modals";
import timeDiff from "@/helpers/date/timeDiff";
import timeDiffAsDecimal from "@/helpers/date/timeDiffAsDecimal";
import store from "@/store/store";
import ClockIcon from "@/components/Icons/ClockIcon.vue";
import LocationIcon from "@/components/Icons/LocationIcon.vue";
import DollarWithCircleIcon from "@/components/Icons/DollarWithCircleIcon.vue";
import RoutingIcon from "@/components/Icons/RoutingIcon.vue";
import { isAustraliaRegion,isUSRegion } from '@/helpers/region/regionHelper.js';
import distanceInMiles from "@/helpers/distance/distance-in-miles.js";
import MissingProfileRequirementsModal from "@/modals/Profile/MissingProfileRequirementsModal.vue";
import { useProfileRequirements } from "@/composables/useProfileRequirements.js";

export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    IonTitle,
    "modal-user-info": UserInfoModal,
    MissingProfileRequirementsModal,
    ClockIcon,
    LocationIcon,
    DollarWithCircleIcon,
    RoutingIcon
  },
  directives: {},
  setup() {
    const $store = useStore();
    const $router = useRouter();
    const route = useRoute();
    const dialogVisible = ref(false);
    const currentUrl = process.env.VUE_APP_CURRENT_URL;
    const setPageClassGlobal = inject("setPageClassGlobal");
    const $modals = inject("$modals");
    const message = inject('messages');
    const googleMaps = inject(["googleMaps"]);
    const bottomDropUp = ref(false);
    const bottomDropUpAcceptShift = ref(false);
    const profileRequirements = useProfileRequirements();

    // Bulk shifts are booked together, so any shift in the requirement window applies.
    // Otherwise only the shifts the locum actually selected are considered.
    function selectionRequiresProfileRequirements() {
      const shifts = formsData.dayForm.jobShifts.value || [];
      const relevantShifts = job.value?.isBlockShift == 1
        ? shifts
        : shifts.filter((shift) => shift.checkboxValue === true);

      return relevantShifts.some((shift) =>
        profileRequirements.shiftRequiresProfileRequirements(shift.date)
      );
    }

    function openAcceptShiftDrawer() {
      if (!selectionRequiresProfileRequirements()) {
        bottomDropUpAcceptShift.value = true;
        return;
      }

      profileRequirements.guardJobBooking(() => {
        bottomDropUpAcceptShift.value = true;
      }, {
        pharmacyId: job.value?.pharmacyId,
        jobProfileRequirements: job.value?.profileRequirements,
        isContractorForPharmacy: job.value?.isContractorForPharmacy,
        contractorInvoicingEnabled: job.value?.contractorInvoicingEnabled,
        internalStaffForPharmacy: job.value?.isInternalStaffOfThisPharmacy
          || job.value?.profileRequirements?.internalStaffForPharmacy,
      });
    }

    const pendingDocumentBanner = ref(false);
    let pendingDocumentBannerTimer = null;
    const pendingDocumentBannerSuccess = ref(false);
    const pendingDocumentBannerMessage = ref("");
    const pendingDocumentList = ref([]);
    const showDocReviewModal = ref(false);
    const selectedDocForReview = ref(null);
    const isAcknowledgingDoc = ref(false);
    const assignAcceptanceTrackingId = ref(null);

    const extractRawDocs = (data) => {
      if (!data) return [];
      if (data.documents && (Array.isArray(data.documents) || typeof data.documents === "object")) {
        return data.documents;
      }
      if (data.document && (Array.isArray(data.document) || typeof data.document === "object")) {
        return data.document;
      }
      if (data.pendingDocuments && (Array.isArray(data.pendingDocuments) || typeof data.pendingDocuments === "object")) {
        return data.pendingDocuments;
      }
      if (data.pending_documents && (Array.isArray(data.pending_documents) || typeof data.pending_documents === "object")) {
        return data.pending_documents;
      }
      return [];
    };

    const extractAcceptanceTrackingId = (data) => {
      if (!data) return null;
      if (typeof data !== "object") return null;

      if (data.acceptance_tracking_id) return data.acceptance_tracking_id;
      if (data.acceptanceTrackingId) return data.acceptanceTrackingId;
      if (data.acceptance_tracking?.id) return data.acceptance_tracking.id;
      if (data.tracking_id) return data.tracking_id;
      if (data.trackingId) return data.trackingId;
      if (data.acceptance_id) return data.acceptance_id;
      if (data.acceptanceId) return data.acceptanceId;

      if (data.data && typeof data.data === "object") {
        const nested = extractAcceptanceTrackingId(data.data);
        if (nested) return nested;
      }

      if (data.response && typeof data.response === "object") {
        const nestedResp = extractAcceptanceTrackingId(data.response.data || data.response);
        if (nestedResp) return nestedResp;
      }

      const docs = extractRawDocs(data);
      if (Array.isArray(docs) && docs.length > 0) {
        for (const doc of docs) {
          if (doc && typeof doc === "object") {
            const docTrackingId =
              doc.acceptance_tracking_id ||
              doc.acceptanceTrackingId ||
              doc.acceptance_tracking?.id ||
              doc.tracking_id ||
              doc.trackingId ||
              doc.acceptance_id ||
              doc.acceptanceId;
            if (docTrackingId) return docTrackingId;
          }
        }
      }

      return null;
    };

    const hasPendingDocs = (data) => {
      if (!data) return false;
      if (data.pending_documents === true || data.pendingDocuments === true) return true;
      const docs = extractRawDocs(data);
      return Array.isArray(docs) ? docs.length > 0 : Object.keys(docs).length > 0;
    };

    const normalizeDocuments = (rawDocs, parentData = null) => {
      if (!rawDocs) return [];
      let list = [];
      if (Array.isArray(rawDocs)) {
        list = rawDocs;
      } else if (typeof rawDocs === "object") {
        list = Object.values(rawDocs);
      }
      const parentTrackingId = extractAcceptanceTrackingId(parentData) || assignAcceptanceTrackingId.value || null;
      return list.map((doc, idx) => {
        const docObj = (doc && typeof doc === "object") ? doc : {};
        const docTrackingId =
          docObj.acceptance_tracking_id ||
          docObj.acceptanceTrackingId ||
          docObj.acceptance_tracking?.id ||
          docObj.tracking_id ||
          docObj.trackingId ||
          docObj.acceptance_id ||
          docObj.acceptanceId ||
          parentTrackingId ||
          assignAcceptanceTrackingId.value ||
          null;

        return {
          id: docObj.document_id || docObj.documentId || docObj.id || `doc_${idx}`,
          document_id: docObj.document_id || docObj.documentId || docObj.id || `doc_${idx}`,
          name: docObj.name || docObj.title || "Onboarding Document",
          required: docObj.required === true || docObj.required === 1 || docObj.required === "1" || docObj.required === "true",
          url: docObj.url || docObj.document_url || docObj.link || "",
          shiftId: docObj.shiftId || docObj.shift_id || null,
          shift_id: docObj.shiftId || docObj.shift_id || null,
          group_user_id: docObj.group_user_id || docObj.group_manager_id || null,
          acceptance_tracking_id: docTrackingId,
          acknowledged: !!docObj.acknowledged || !!docObj.accepted || false,
          ...docObj,
        };
      });
    };

    const areAllRequiredDocsAccepted = computed(() => {
      if (!pendingDocumentList.value || pendingDocumentList.value.length === 0) {
        return true;
      }
      return pendingDocumentList.value
        .filter((doc) => doc.required)
        .every((doc) => doc.acknowledged);
    });

    const handleDocItemClick = (doc) => {
      selectedDocForReview.value = doc;
      showDocReviewModal.value = true;
    };

    const confirmAcknowledgeDoc = async () => {
      if (!selectedDocForReview.value) return;
      try {
        isAcknowledgingDoc.value = true;
        const shiftIds = Array.isArray(selectedDocForReview.value.shiftId)
          ? selectedDocForReview.value.shiftId
          : [selectedDocForReview.value.shiftId || selectedDocForReview.value.shift_id || getSelectedShiftsId()[0]];

        const trackingId =
          selectedDocForReview.value.acceptance_tracking_id ||
          selectedDocForReview.value.acceptanceTrackingId ||
          selectedDocForReview.value.tracking_id ||
          assignAcceptanceTrackingId.value ||
          null;

        const payload = {
          document_id: selectedDocForReview.value.document_id || selectedDocForReview.value.id,
          shift_id: shiftIds[0] || null,
          shift_ids: shiftIds,
          status: "accepted"
        };

        if (trackingId) {
          payload.acceptance_tracking_id = trackingId;
        }

        const groupUserId =
          selectedDocForReview.value.group_user_id ||
          selectedDocForReview.value.group_manager_id;
        if (groupUserId) {
          payload.group_user_id = groupUserId;
        }

        const invId =
          selectedDocForReview.value.invitation_id ||
          selectedDocForReview.value.invitationId ||
          selectedDocForReview.value.internal_pool_invitation_id;
        if (invId) {
          payload.invitation_id = invId;
        }
        
        console.log("Calling LOCUM_ACKNOWLEDGE_ONBOARDING_DOCUMENT with payload:", payload);
        await $store.dispatch("LOCUM_ACKNOWLEDGE_ONBOARDING_DOCUMENT", payload);
        
        selectedDocForReview.value.acknowledged = true;
        const found = pendingDocumentList.value.find(
          (d) => (d.document_id && d.document_id === selectedDocForReview.value.document_id) || (d.id && d.id === selectedDocForReview.value.id) || d.name === selectedDocForReview.value.name
        );
        if (found) {
          found.acknowledged = true;
        }

        ElMessage({
          type: "success",
          message: `${selectedDocForReview.value.name} acknowledged successfully!`,
        });

        showDocReviewModal.value = false;

        if (areAllRequiredDocsAccepted.value) {
          pendingDocumentBannerSuccess.value = true;
          pendingDocumentBannerMessage.value = "All required documents acknowledged! You can now proceed to accept/apply.";
          pendingDocumentBanner.value = true;
        }
      } catch (err) {
        console.error("Acknowledge document error:", err);
        ElMessage({
          type: "error",
          message: (err && err.message) || "Failed to acknowledge document. Please try again.",
        });
      } finally {
        isAcknowledgingDoc.value = false;
      }
    };

    const isImageDoc = (url) => {
      if (!url) return false;
      const cleanUrl = url.split("?")[0].toLowerCase();
      return /\.(png|jpe?g|gif|webp|svg|bmp)$/i.test(cleanUrl);
    };

    const isPdfDoc = (url) => {
      if (!url) return false;
      const cleanUrl = url.split("?")[0].toLowerCase();
      return /\.pdf$/i.test(cleanUrl);
    };

    const isDownloadingDoc = ref(false);
    const downloadDoc = async (doc) => {
      if (!doc || !doc.url) return;
      try {
        isDownloadingDoc.value = true;

        let extension = "";
        try {
          const path = doc.url.split("?")[0];
          const parts = path.split(".");
          if (parts.length > 1) {
            extension = "." + parts.pop().toLowerCase();
          }
        } catch (e) {
          // ignore
        }

        let filename = doc.name ? doc.name.trim() : "onboarding-document";
        if (extension && !filename.toLowerCase().endsWith(extension)) {
          filename += extension;
        } else if (!extension) {
          if (isPdfDoc(doc.url)) filename += ".pdf";
          else if (isImageDoc(doc.url)) filename += ".png";
        }

        let downloaded = false;

        // Method 1: Fetch API Blob
        try {
          const response = await fetch(doc.url, { mode: "cors" });
          if (response.ok) {
            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.style.display = "none";
            link.href = blobUrl;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            setTimeout(() => {
              document.body.removeChild(link);
              window.URL.revokeObjectURL(blobUrl);
            }, 300);
            downloaded = true;
          }
        } catch (fetchErr) {
          console.warn("Fetch blob download failed, trying XHR:", fetchErr);
        }

        // Method 2: XHR Blob
        if (!downloaded) {
          try {
            await new Promise((resolve, reject) => {
              const xhr = new XMLHttpRequest();
              xhr.open("GET", doc.url, true);
              xhr.responseType = "blob";
              xhr.onload = function () {
                if (this.status === 200 || this.status === 0) {
                  const blobUrl = window.URL.createObjectURL(this.response);
                  const link = document.createElement("a");
                  link.style.display = "none";
                  link.href = blobUrl;
                  link.download = filename;
                  document.body.appendChild(link);
                  link.click();
                  setTimeout(() => {
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(blobUrl);
                    resolve(true);
                  }, 300);
                } else {
                  reject(new Error("XHR status " + this.status));
                }
              };
              xhr.onerror = reject;
              xhr.send();
            });
            downloaded = true;
          } catch (xhrErr) {
            console.warn("XHR blob download failed, trying Canvas / Anchor:", xhrErr);
          }
        }

        // Method 3: Canvas for images
        if (!downloaded && isImageDoc(doc.url)) {
          try {
            await new Promise((resolve, reject) => {
              const img = new Image();
              img.crossOrigin = "anonymous";
              img.onload = () => {
                try {
                  const canvas = document.createElement("canvas");
                  canvas.width = img.naturalWidth || img.width;
                  canvas.height = img.naturalHeight || img.height;
                  const ctx = canvas.getContext("2d");
                  ctx.drawImage(img, 0, 0);
                  canvas.toBlob((blob) => {
                    if (blob) {
                      const blobUrl = window.URL.createObjectURL(blob);
                      const link = document.createElement("a");
                      link.style.display = "none";
                      link.href = blobUrl;
                      link.download = filename;
                      document.body.appendChild(link);
                      link.click();
                      setTimeout(() => {
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(blobUrl);
                        resolve(true);
                      }, 300);
                    } else {
                      reject(new Error("Canvas blob is null"));
                    }
                  }, "image/png");
                } catch (err) {
                  reject(err);
                }
              };
              img.onerror = reject;
              img.src = doc.url;
            });
            downloaded = true;
          } catch (canvasErr) {
            console.warn("Canvas download failed, falling back to anchor:", canvasErr);
          }
        }

        // Method 4: Hidden anchor fallback
        if (!downloaded) {
          const link = document.createElement("a");
          link.style.display = "none";
          link.href = doc.url;
          link.setAttribute("download", filename);
          link.setAttribute("target", "_self");
          document.body.appendChild(link);
          link.click();
          setTimeout(() => {
            document.body.removeChild(link);
          }, 300);
        }

        ElMessage({
          type: "success",
          message: `Downloading "${filename}"...`,
        });
      } catch (err) {
        console.error("Download error:", err);
        ElMessage({
          type: "error",
          message: "Could not download document.",
        });
      } finally {
        isDownloadingDoc.value = false;
      }
    };

    const setting = ref({});
    const activeNames = ref(["1"]);
    const isAustralia = isAustraliaRegion();
    const isUS = isUSRegion();
    let job = ref({});
    let shifts = ref([]);
    const $moment = inject(["$moment"]);
    const userData = $store.getters.GET_USER_DATA;
    const groupSubscriptionExist = ref(userData.groupSubscriptionExist ? userData.groupSubscriptionExist : false);
    const userRole = userData.role;
    const isButtonDisabled = computed(() => {
      // return job.value.isInternalStaffOfThisPharmacy && !groupSubscriptionExist.value;
      return false;
    });

    const formsDataArray = {
      dayForm: {
        jobShifts: {
          value: [],
          errors: null,
          validators: [
            {
              validator: (rule, formField, callback) => {
                let errors = formsData.dayForm.jobShifts.errors;
                let formName = formField.formName;

                if (!errors || !errors.length) {
                  setFormValidation(formName, rule.field, true);
                  callback();
                } else {
                  setFormValidation(formName, rule.field, false);
                  callback(new Error(""));
                }
              },
            },
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "jobShiftsBook",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
      },
    };

    (async () => {
      try {
        if (!job.value.distance) {
          let needToRetrieveDistance = true;
          let jobsDistancesCache = store.getters.getJobDistancesData.length
            ? store.getters.getJobDistancesData
            : []; // data from cache

          for (let cacheItem of jobsDistancesCache) {
            if (cacheItem.id == job.value.pharmacyId && cacheItem.cachedAt) {
              //check if distance exists in cache
              console.log("distance item loaded from cache");
              console.log(cacheItem.distance);

              needToRetrieveDistance = false;
              job.value.distance = cacheItem.distance;
              break;
            }
          }

          if (needToRetrieveDistance) {
            const result = await googleMaps.getDistance(userData.address, [
              job.value.pharmacy.address,
            ]);

            let distance = null;
            let jobDistance = result[0].elements[0].distance
              ? result[0].elements[0].distance.text
              : null;

            if (jobDistance) {
              jobDistance = jobDistance.replace(",", ".");
              if (new RegExp("(.*)(km|км)$", "gm").test(jobDistance)) {
                distance = parseFloat(jobDistance);
              } else if (new RegExp("(.*)(m|м)$", "gm").test(jobDistance)) {
                distance = parseFloat(jobDistance) / 1000;
              } else {
                console.log("");
              }
            }
            console.log("----- set distance -----");
            console.log(distance);

            job.value.distance = distance;
          }
        }
      } catch (error) {
        console.log(error);
      }
    })();

    // Computed property to determine the button label
    const buttonLabel = computed(() => {
      const allChecked = formsData.dayForm.jobShifts.value.every(
        (shift) => shift.disabled || shift.checkboxValue === true
      );
      return allChecked ? 'Unselect All Shifts' : 'Select All Shifts';
    });

    const SelectAllShifts = () => {
      // Determine if all enabled shifts are already checked
      const allChecked = formsData.dayForm.jobShifts.value.every(
        (shift) => shift.disabled || shift.checkboxValue === true
      );

      // Set the checkboxValue for each shift accordingly
      formsData.dayForm.jobShifts.value.forEach((shift) => {
        if (!shift.disabled) {
          shift.checkboxValue = !allChecked;
        }
      });
    };


    const checkboxValueChange = (value) => {
      if (job.value.isBlockShift == 1) {
        formsData.dayForm.jobShifts.value.forEach((shift) => {
          if (value && shift.abilities && shift.abilities["assign"] == true) {
            shift.checkboxValue = true;
          } else {
            shift.checkboxValue = false;
          }
        });
        nextTick(() => {
          checkFormValidation("dayForm", true);

        });
      } else {
        if (formsData.dayForm.jobShifts.errors) {
          delete formsData.dayForm.jobShifts.errors;
        }
        nextTick(() => {
          checkFormValidation("dayForm", true);
        });
      }
    };

  
    const checkJobDateStart = (dateStart, endDate, trim = true) => {
            let start = $moment(dateStart, ["YYYY/MM/DD", "YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss.SSSZ", "DD MMM YYYY"]);
            let end = $moment(endDate, ["YYYY/MM/DD", "YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss.SSSZ", "DD MMM YYYY"]);

            if (start.format("YYYY") !== end.format("YYYY")) {
                // If years are different, return full date with year
                if (isAustralia.value) {
                    return start.format("DD MMM YYYY");
                } else {
                    return start.format("MMM DD YYYY");
                }
             }

            if (start.format("MMMM") == end.format("MMMM")) {
                if (start.format("D") == end.format("D")) {
                    return null;
                }
                if(isAustralia.value){

                    return start.format("DD ");
                }else{
                    return start.format("MMM DD");
                }
            } else {
              if(isAustralia.value){
                    return start.format("DD " + (trim ? "MMM" : "MMMM") );
                }else{
                    return start.format( (trim ? "MMM " : "MMMM ") + "DD" );
                }
            }
        };

    const getSelectedShiftsId = () => {
      return formsData.dayForm.jobShifts.value
        .filter((day) => {
          if (day.checkboxValue == true) {
            return true;
          }
        })
        .map((day) => day.id);
    };

    const userInfoModal = ref({
      name: "userInfo",
      user: {},
    });

    const userInfoModalOpen = () => {
      userInfoModal.value.user = job.value.pharmacy;
      $modals.open("userInfoModal");
    };

    const goBack = () => {
      if(userRole==='locum' || userRole==='pharmacy' || userRole==='agency'){
        goToSearch();

      }else{
        $router.push({ name: "job_seeker_index" });
      }
      
    };

    const goToSearch = () => {
      $router.push({ name: "search" });
    }

    const goNext = () => {
      $store.dispatch("setJobDetails", {
        job: job.value,
      });
      $router.push({
        name: "job_book_calendar",
      });
    };


    if (job.value.blockedByLocum) {

      ElMessage({

        type: "error",

        message: "You have blocked this pharmacy. Please unblock to apply for this job.",

      });

      goToSearch();

    }
     //job shift apply function
    const applyShift = (formName, jobId) => {
      formsRefs[formName].value.validate((valid) => {
        if (valid) {
          (async () => {
            try {
              const res = await $store.dispatch("APPLY_JOB_SHIFTS_LIST", {
                shift_ids: getSelectedShiftsId(),
                job_id: jobId
              });
              console.log("APPLY_JOB_SHIFTS_LIST response:", res);

              const trackingId = extractAcceptanceTrackingId(res);
              if (trackingId) {
                assignAcceptanceTrackingId.value = trackingId;
              }

              if (res && hasPendingDocs(res)) {
                console.log("Onboarding documents are pending. Triggering banner and checklist.", res);
                const rawDocs = extractRawDocs(res);
                pendingDocumentList.value = normalizeDocuments(rawDocs, res);
                pendingDocumentBannerSuccess.value = false;
                pendingDocumentBannerMessage.value = res.message || "You can't accept this shift yet. Required onboarding documents are still pending.";
                pendingDocumentBanner.value = true;
                bottomDropUpAcceptShift.value = true;
                if (pendingDocumentBannerTimer) clearTimeout(pendingDocumentBannerTimer);
                pendingDocumentBannerTimer = setTimeout(() => {
                  pendingDocumentBanner.value = false;
                }, 30000);
                return;
              }

              if (res && res.success === false) {
                  ElMessage({ type: "error", message: res.message });
                  return;
              }

              pendingDocumentBannerSuccess.value = true;
              pendingDocumentBannerMessage.value = "Thank you for applying for the Shift. We will notify you when the shift is offered to you";
              pendingDocumentBanner.value = true;
              if (pendingDocumentBannerTimer) clearTimeout(pendingDocumentBannerTimer);
              pendingDocumentBannerTimer = setTimeout(() => {
                pendingDocumentBanner.value = false;
              }, 30000);

              setTimeout(() => {
                $router.push({
                  name: "search",
                });
              }, 2000);
            } catch (error) {
              console.error("APPLY_JOB_SHIFTS_LIST error caught:", error);
              const trackingId = extractAcceptanceTrackingId(error);
              if (trackingId) {
                assignAcceptanceTrackingId.value = trackingId;
              }
              if (error && hasPendingDocs(error)) {
                console.log("Onboarding documents are pending (from catch block). Triggering banner and checklist.", error);
                const rawDocs = extractRawDocs(error);
                pendingDocumentList.value = normalizeDocuments(rawDocs, error);
                pendingDocumentBannerSuccess.value = false;
                pendingDocumentBannerMessage.value = error.message || "You can't accept this shift yet. Required onboarding documents are still pending.";
                pendingDocumentBanner.value = true;
                bottomDropUpAcceptShift.value = true;
                if (pendingDocumentBannerTimer) clearTimeout(pendingDocumentBannerTimer);
                pendingDocumentBannerTimer = setTimeout(() => {
                  pendingDocumentBanner.value = false;
                }, 30000);
                return;
              }
              let errorMessage = [];
              formsData.dayForm.jobShifts.value.filter((shift) => {
                let errorsArray = error && error.errors && error.errors.some((element) => {
                  if (element.id == shift.id) {
                    errorMessage.push({
                      date: shift.date,
                      message: element.message,
                    });
                    return true;
                  }
                });
                if (!errorsArray) errorMessage.push(null);
              });
              console.log(errorMessage);
              formsData.dayForm.jobShifts.errors = errorMessage;
              checkFormValidation("dayForm", true);
            }
          })();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    };

    const submit = (formName) => {
      formsRefs[formName].value.validate((valid) => {
        console.log("checking validation", valid);
        if (valid) {
          (async () => {
            try {
              const res = await $store.dispatch("SAVE_JOB_SHIFTS_LIST", {
                shifts_ids: getSelectedShiftsId(),
              });
              console.log("SAVE_JOB_SHIFTS_LIST response:", res);

              const trackingId = extractAcceptanceTrackingId(res);
              if (trackingId) {
                assignAcceptanceTrackingId.value = trackingId;
              }

              if (res && hasPendingDocs(res)) {
                console.log("Onboarding documents are pending. Triggering banner and checklist.", res);
                const rawDocs = extractRawDocs(res);
                pendingDocumentList.value = normalizeDocuments(rawDocs, res);
                pendingDocumentBannerSuccess.value = false;
                pendingDocumentBannerMessage.value = res.message || "You can't accept this shift yet. Required onboarding documents are still pending.";
                pendingDocumentBanner.value = true;
                bottomDropUpAcceptShift.value = true;
                if (pendingDocumentBannerTimer) clearTimeout(pendingDocumentBannerTimer);
                pendingDocumentBannerTimer = setTimeout(() => {
                  pendingDocumentBanner.value = false;
                }, 30000);
                return;
              }

              if (res && res.success === false) {
                  ElMessage({ type: "error", message: res.message });
                  return;
              }

              pendingDocumentBannerSuccess.value = true;
              pendingDocumentBannerMessage.value = "Thank You! Your booking has been confirmed.";
              pendingDocumentBanner.value = true;
              if (pendingDocumentBannerTimer) clearTimeout(pendingDocumentBannerTimer);
              pendingDocumentBannerTimer = setTimeout(() => {
                pendingDocumentBanner.value = false;
              }, 30000);

              setTimeout(() => {
                $router.push({
                  name: "search",
                });
                if (!job.value.collaboratedBefore)
                  $router.push({
                    name: "chat_message",
                    params: {
                      chatId: `${job.value.pharmacyId}.${userData.id}`,
                      firstCollaborate: true,
                    },
                  });
              }, 2000);
            } catch (error) {
              console.error("SAVE_JOB_SHIFTS_LIST error caught:", error);
              const trackingId = extractAcceptanceTrackingId(error);
              if (trackingId) {
                assignAcceptanceTrackingId.value = trackingId;
              }
              if (error && hasPendingDocs(error)) {
                console.log("Onboarding documents are pending (from catch block). Triggering banner and checklist.", error);
                const rawDocs = extractRawDocs(error);
                pendingDocumentList.value = normalizeDocuments(rawDocs, error);
                pendingDocumentBannerSuccess.value = false;
                pendingDocumentBannerMessage.value = error.message || "You can't accept this shift yet. Required onboarding documents are still pending.";
                pendingDocumentBanner.value = true;
                bottomDropUpAcceptShift.value = true;
                if (pendingDocumentBannerTimer) clearTimeout(pendingDocumentBannerTimer);
                pendingDocumentBannerTimer = setTimeout(() => {
                  pendingDocumentBanner.value = false;
                }, 30000);
                return;
              }
              let errorMessage = [];
              formsData.dayForm.jobShifts.value.filter((shift) => {
                let errorsArray = error && error.errors && error.errors.some((element) => {
                  if (element.id == shift.id) {
                    errorMessage.push({
                      date: shift.date,
                      message: element.message,
                    });
                    return true;
                  }
                });
                if (!errorsArray) errorMessage.push(null);
              });
              console.log(errorMessage);
              formsData.dayForm.jobShifts.errors = errorMessage;
              checkFormValidation("dayForm", true);
            }
          })();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    };

    onBeforeMount(() => {
      // Get job data from store (already fetched by router)
      const jobData = $store.getters.getJobDetails.job;
      
      if (!jobData || !jobData.id) {
        // Fallback: fetch if not in store (shouldn't happen due to router guard)
        return new Promise((resolve) => {
          $store
            .dispatch("GET_JOB_INFO", {
              jobId: route.params.jobId,
              params: {
                with: "shift_availability_stats,pharmacy,pharmacy.settings,pharmacy.address,shifts,shifts.abilities,settings, shiftApplications",
              },
            })
            .then((response) => {
              processJobData(response.data);
              resolve(response);
            });
        });
      }

      // Use job data from store (already fetched by router)
      processJobData(jobData);
    });

    const processJobData = (jobFetchResult) => {
      if(jobFetchResult.error) {
        ElMessage({
          type: "error",
          message: jobFetchResult.message,
        });
        goToSearch();
        return;
      }

      job.value = jobFetchResult;
      
      if (jobFetchResult.blacklistedByPharmacy) {
        goToSearch();
        return;
      }
      
      if (jobFetchResult.blockedByLocum) {
        ElMessage({
          type: "error",
          message: "You have blocked this pharmacy. Please unblock to apply for this job.",
        });
        goToSearch();
        return;
      }
      
      job.value.blockedByLocum = jobFetchResult.blockedByLocum;
      job.value.distance = jobFetchResult.distance;

      // Extract pending documents if already present in job details
      if (hasPendingDocs(jobFetchResult)) {
        const trackingId = extractAcceptanceTrackingId(jobFetchResult);
        if (trackingId) {
          assignAcceptanceTrackingId.value = trackingId;
        }
        const rawDocs = extractRawDocs(jobFetchResult);
        pendingDocumentList.value = normalizeDocuments(rawDocs, jobFetchResult);
      }
      
      // Initialize shifts and process them
      formsData.dayForm.jobShifts.value = jobFetchResult.shifts || [];

      formsData.dayForm.jobShifts.value.forEach((shift) => {

        moment().diff(
          moment(
            shift.date + " " + shift.startTime,
            "YYYY/MM/DD HH:mm:ss"
          ),
          "minutes"
        ) <= 0
          ? (shift.disabled = false)
          : (() => {

            shift.disabled = true;
            shift.checkboxValue = false;
          })();

        if (shift.userId) {
          shift.disabled = true;
          shift.checkboxValue = false;
        }

        if (shift.abilities) {
          const isAssignAvailable = shift.abilities["assign"] == true;

          shift.checkboxValue = isAssignAvailable ? true : false;
          shift.disabled = isAssignAvailable ? false : true;
        }

        if (shift.totalShiftApplications == job.value.maximumApplicationLimit) {
          shift.disabled = true;
          shift.checkboxValue = false;

        }

        if (shift.shiftApplicationData && shift.shiftApplicationData.status) {
          shift.disabled = true;
          shift.checkboxValue = false;
        }
        if (shift.checkboxValue == undefined) {
          shift.checkboxValue = true;
        }
      });

      // removing disabled shift from array
      const newShifts = formsData.dayForm.jobShifts.value.filter(object => {
        return object.disabled !== true;
      });

      formsData.dayForm.jobShifts.value = newShifts;

      if (formsData.dayForm.jobShifts.value.length <= 0) {
        formsData.dayForm.disabled = true
      }
    };

    onMounted(() => {
      setPageClassGlobal("global_job_book_page");
      setFormRefs();
      checkFormValidation("dayForm", true);
    });

    const formatHourlyRate = (regularRate, weekendRate) => {
      let formattedString = "";
      if (regularRate) {

        formattedString += formatCurrency(regularRate);
      }

      if (regularRate && weekendRate) {
        formattedString += " - ";
      }

      if (weekendRate) {
        formattedString += formatCurrency(weekendRate);
      }
      return formattedString;
    };

    const formatCurrency = (rate) => {
      return new Intl.NumberFormat("en-AU", {
        style: "currency",
        currency: "AUD",
      }).format(rate);
    };

    const handleChange = (e) => {
      e.stoppropagation();
    };
    const confirmedHours = (confirmedHours, startTime, endTime) => {
      let hours = 0;
      if (confirmedHours == 0 || confirmedHours == null) {
        const start = moment(startTime, "HH:mm:ss");
        const end = moment(endTime, "HH:mm:ss");

        hours = timeDiff(start, end);
      } else {
        const string = String(confirmedHours);
        const numHours = string.split(".")[0];
        let minutes = string.split(".")[1];

        if (!minutes) {
          const time = numHours + ":" + "00";
          hours = String(time);
        } else {
          minutes = Number.parseFloat(`0.${minutes}`) * 60;
          hours = numHours + ":" + minutes.toFixed(0);
        }
      }

      return hours;
    };
    const Sum = (job, shift, i) => {
      let Sum;
      let confirmedHoursVal;
      let payRate;
      let travelCompensation = 0;
      const globalTravelCompensationValue =
        process.env.VUE_APP_TRAVEL_COMPENSATION;

      if (userRole === "locum") {
        if (shift.locum == null && (shift.payRateExecSuper == null || shift.payRateExecSuper == 0)) {
          payRate = shift.recommendedRate;
        } else {
          payRate = shift.payRateExecSuper;
        }
      } else {
        payRate = shift.payRateExecSuper;
      }

      if (shift.confirmedHours == 0 || shift.confirmedHours == null) {
        const start = moment(shift.startTime, "HH:mm:ss");
        const end = moment(shift.endTime, "HH:mm:ss");

        confirmedHoursVal = timeDiffAsDecimal(start, end);
      } else {
        confirmedHoursVal = shift.confirmedHours;
      }

      if (shift.travelCompensation === 0 && shift.adminUpdatedTravelCompensation == false) {
        let jobDistance = shift.distance ? shift.distance : null;

        if (jobDistance === null && job.distance) {
          jobDistance = job.distance;
        }

        if (job.isInternalStaffOfThisPharmacy) {
          jobDistance = 0;
        }

        let distance = jobDistance;

        if (job.settings.payingForTravel == 1) {
          if (distance * 2 > 50) {
            travelCompensation =
              (distance * 2 - 50) * globalTravelCompensationValue;
          } else {
            travelCompensation = 0;
          }
        } else if (job.settings.payingForTravel == 2) {
          travelCompensation = distance * 2 * globalTravelCompensationValue;
        } else if (job.settings.payingForTravel === 3 && job.maxTravelCompensation !== 0) {
          let realTravelCost = distance * 2 * globalTravelCompensationValue;
          if (realTravelCost > job.maxTravelCompensation) {
            travelCompensation = job.maxTravelCompensation;
          } else {
            travelCompensation = distance * 2 * globalTravelCompensationValue;
          }
        }
        if (!job.settings.payingForTravel) {
          travelCompensation = 0;
        }
      } else {
        travelCompensation = shift.travelCompensation;
      }

      // 🚀 APPLY FIRST & LAST SHIFT LOGIC (skip when admin set per-shift travel)
      if (job.enableTravelAllowanceForFirstAndLastDay === 1 && shift.adminUpdatedTravelCompensation !== true) {
        const shiftsLength = job.shifts.length;
        const isFirstShift = i === 0;
        const isLastShift = i === shiftsLength - 1;

        if (isFirstShift || isLastShift) {
          travelCompensation = travelCompensation / 2;
        } else {
          travelCompensation = 0; // Middle shifts return "-"
        }
      }

      Sum = payRate * confirmedHoursVal + travelCompensation;
      if (Sum != 0) {
        Sum = new Intl.NumberFormat("en-AU", {
          style: "currency",
          currency: "AUD",
        }).format(Sum);
      } else {
        Sum = "-";
      }
      return Sum;
    };

    const Rate = (shift) => {
      if (userRole === "locum") {
        if (shift.locum == null && (shift.payRateExecSuper == null || shift.payRateExecSuper == 0)) {
          return Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
          }).format(shift.recommendedRate);
        } else {
          return Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
          }).format(shift.payRateExecSuper);
        }
      }
    };
    const superRate = (shift) => {
      if (userRole === "locum") {
        
         let confirmedHoursVal = 0;
        if (shift.confirmedHours == 0 || shift.confirmedHours == null) {
        const start = moment(shift.startTime, "HH:mm:ss");
        const end = moment(shift.endTime, "HH:mm:ss");

        confirmedHoursVal = timeDiffAsDecimal(start, end);
      } else {
        confirmedHoursVal = shift.confirmedHours;
      }
                

        const superRate = shift.superRate * confirmedHoursVal;
        return Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
          }).format(superRate);
       
      }
    };

    const distance = (job, shift) => {
      let result;
      const globalTravelCompensationValue =
        process.env.VUE_APP_TRAVEL_COMPENSATION;

      if (!shift.distance && !job.distance) {
        result = "-";
      } else {
        let distance;
        distance = shift.historyDistance ? shift.historyDistance : job.distance;
        if (job.settings.payingForTravel == 1) {
          if (distance * 2 > 50) {
            const result1 = (distance * 2 - 50) * globalTravelCompensationValue;
            result = new Intl.NumberFormat("en-AU", {
              style: "currency",
              currency: "AUD",
            }).format(result1);
          } else {
            result = "-";
          }
        } else if (job.settings.payingForTravel == 2) {
          result = new Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
          }).format(distance * 2 * globalTravelCompensationValue);
        } else if (job.settings.payingForTravel == 3) {
          result = new Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
          }).format(job.maxTravelCompensation);
        }
      }

      return result;
    };
    const share = () => {
      bottomDropUp.value = false;
      const link = currentUrl + "job-preview/" + job.value.id;
      const el = document.createElement("textarea");
      el.value = link;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      ElMessageBox.alert("Link to current job copied to clipboard", "Thanks", {
        type: "success",
        showCancelButton: false,
        confirmButtonText: "Close",
        callback: () => {
          console.log("btn click");
        },
      });
    };

    const blockPharmacy = () => {
      bottomDropUp.value = false;
      const isPharmacyBlocked = job.value.blockedByLocum;
      const type = isPharmacyBlocked ? 'unblock' : 'block';
      let title = isPharmacyBlocked ? "Are you sure you want to unblock this pharmacy?" : "Are you sure you want to block this pharmacy?";
      let message = isPharmacyBlocked ? "" : "You will no longer see their shifts";
      ElMessageBox.confirm(
        message, title,
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        }
      )
        .then(() => {
          $store
            .dispatch("BLOCK_PHARMACY", {
              pharmacyId: job.value.pharmacyId,
              type: type
            })
            .then(() => {
              ElMessage({
                type: "success",
                message: `Pharmacy ${type}ed successfully`,
              });
              $store.dispatch("GET_LOCUM_BLOCKED_PHARMACIES");
              goToSearch();
            });
        })
        .catch(() => { });
    }

    const showShiftInformation = (shift) => {
      if(shift.job.isInternalStaffOfThisPharmacy && shift.shiftSubscription){
        return false;
      }
      if (!shift.userId) return true;
      if (shift.userId === userData.id) return true;
      return false;
    };

    // const travelCompensationCount = (job, shift, i) => {
    //   console.log("🚀 ~ travelCompensationCount ~ i:", i)
    //   if ((shift.travelCompensation >= 0 && shift.adminUpdatedTravelCompensation == true) || (shift.travelCompensation === 0 && shift.adminUpdatedTravelCompensation == true)) {
       
    //     const convertedTravelRate = formatCurrency(shift.travelCompensation);
    //     return convertedTravelRate;
    //   } else {
    //     if (
    //       job.settings.payingForTravel === 0 &&
    //       shift.adminUpdatedTravelCompensation == false
    //     ) {
    //       return "-";
    //     }

    //     if (job.settings.payingForTravel === 3 && job.maxTravelCompensation !== 0) {
    //       let travelCompensation;
          
    //       //admin may change the travel compensation for the job via job menu in the admin panel
    //       //the changed travel compensation only reflects on the shifts that has not been booked
    //       //so to keep track of previous travel compensations, we store the travel compensation in the shift table as well naming the column as job_max_travel_compensation
    //       //job_max_travel_compensation in the shift table is updated when admin updates the travel compensation for the job
    //       //where the shifts job_max_travel_compensation that has been booked is updated with previous travel compensation and the shifts that has not been booked is updated with the new travel compensation
    //       let maxTravelCompensation = shift.jobMaxTravelCompensation && shift.userId ? shift.jobMaxTravelCompensation : job.maxTravelCompensation;
    //       const globalTravelCompensationValue = process.env.VUE_APP_TRAVEL_COMPENSATION;
    //       let jobDistance;

    //       if (shift.distance) {
    //         jobDistance = shift.distance;
    //       } else {
    //         jobDistance = shift.historyDistance ? shift.historyDistance : job.distance;
    //       }

    //       if (jobDistance) {
    //         let distance = jobDistance;
    //         travelCompensation = distance * 2 * globalTravelCompensationValue;
    //         if (travelCompensation > maxTravelCompensation) {
    //           const convertedTravelRate = formatCurrency(maxTravelCompensation);
    //           return convertedTravelRate;
    //         } else {
    //           travelCompensation = new Intl.NumberFormat("en-AU", {
    //             style: "currency",
    //             currency: "AUD",
    //           }).format(distance * 2 * globalTravelCompensationValue);
    //           return travelCompensation;
    //         }
    //       } else {
    //         const convertedTravelRate = formatCurrency(maxTravelCompensation);
    //         return convertedTravelRate;
    //       }

    //     } else {
    //       return distance(job, shift);
    //     }

    //   }

    // };


    const travelCompensationCount = (job, shift, i) => {
      let travelCompensation = calculateTravelCompensation(job, shift); // Call the original function

      if (shift.adminUpdatedTravelCompensation === true) {
        return travelCompensation;
      }

      if (job.enableTravelAllowanceForFirstAndLastDay === 1) {
        const shiftsLength = job.shifts.length;
        const isFirstShift = i === 0;
        const isLastShift = i === shiftsLength - 1;

        if (isFirstShift || isLastShift) {
          if (typeof travelCompensation === "string" && travelCompensation === "-") {
            return "-"; // Keep '-' as it is
          }
          
          // Extract numeric value from currency format (handles cases like "$8.00")
          let numericValue = parseFloat(travelCompensation.replace(/[^0-9.-]+/g, ""));
          let halfCompensation = numericValue / 2;

          // Format back to currency using Intl.NumberFormat
          return new Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
          }).format(halfCompensation);
        } else {
          return "-";
        }
      }

      return travelCompensation; // Default behavior
    };


    // Helper function to calculate the full travel compensation
    const calculateTravelCompensation = (job, shift) => {
      if ((shift.travelCompensation >= 0 && shift.adminUpdatedTravelCompensation == true) || (shift.travelCompensation === 0 && shift.adminUpdatedTravelCompensation == true)) {
       
        const convertedTravelRate = formatCurrency(shift.travelCompensation);
        return convertedTravelRate;
      }else if(shift.travelCompensation >= 0 ){
        const convertedTravelRate = formatCurrency(shift.travelCompensation);
        return convertedTravelRate;
      } else {
        if (
          job.settings.payingForTravel === 0 &&
          shift.adminUpdatedTravelCompensation == false
        ) {
          return "-";
        }

        if (job.settings.payingForTravel === 3 && job.maxTravelCompensation !== 0) {
          let travelCompensation;
          
          //admin may change the travel compensation for the job via job menu in the admin panel
          //the changed travel compensation only reflects on the shifts that has not been booked
          //so to keep track of previous travel compensations, we store the travel compensation in the shift table as well naming the column as job_max_travel_compensation
          //job_max_travel_compensation in the shift table is updated when admin updates the travel compensation for the job
          //where the shifts job_max_travel_compensation that has been booked is updated with previous travel compensation and the shifts that has not been booked is updated with the new travel compensation
          let maxTravelCompensation = shift.jobMaxTravelCompensation && shift.userId ? shift.jobMaxTravelCompensation : job.maxTravelCompensation;
          const globalTravelCompensationValue = process.env.VUE_APP_TRAVEL_COMPENSATION;
          let jobDistance;

          if (shift.distance) {
            jobDistance = shift.distance;
          } else {
            jobDistance = shift.historyDistance ? shift.historyDistance : job.distance;
          }

          if (jobDistance) {
            let distance = jobDistance;
            travelCompensation = distance * 2 * globalTravelCompensationValue;
            if (travelCompensation > maxTravelCompensation) {
              const convertedTravelRate = formatCurrency(maxTravelCompensation);
              return convertedTravelRate;
            } else {
              travelCompensation = new Intl.NumberFormat("en-AU", {
                style: "currency",
                currency: "AUD",
              }).format(distance * 2 * globalTravelCompensationValue);
              return travelCompensation;
            }
          } else {
            const convertedTravelRate = formatCurrency(maxTravelCompensation);
            return convertedTravelRate;
          }

        } else {
          return distance(job, shift);
        }

      }

    };




    const getScriptName = (scriptId) => {
      let allScript = setting.value.scripts;
      return allScript.filter((x) => x.id == scriptId)[0].name;
    };

    const getSoftwareName = (softwareId) => {
      let allScript = setting.value.software;
      return allScript.filter((x) => x.id == softwareId)[0].name;
    };

    (async () => {
      try {
        const settingCall = await $store.dispatch("GET_ENVIRONMENT_SETTING");
        Object.assign(setting.value, settingCall);
      } catch (error) {
        console.log(error);
      }
    })();


    // Function to check whether to display the content
    const shouldDisplay = computed(() => {
      return false;
    });

    const {
      checkFormValidation,
      setFormValidation,
      setFormRefs,
      formsData,
      formsRefs,
    } = formHooks(formsDataArray);

    return {
      travelCompensationCount,
      showShiftInformation,
      formatHourlyRate,
      formsData,
      handleChange,
      checkFormValidation,
      setFormValidation,
      goBack,
      goNext,
      submit,
      job,
      shifts,
      checkJobDateStart,
      checkboxValueChange,
      userInfoModalOpen,
      userInfoModal,
      Sum,
      confirmedHours,
      Rate,
      distance,
      share,
      dialogVisible,
      userData,
      groupSubscriptionExist,
      isButtonDisabled,
      applyShift,
      activeNames,
      getScriptName,
      getSoftwareName,
      setting,
      bottomDropUp,
      blockPharmacy,
      formatCurrency,
      superRate,
      bottomDropUpAcceptShift,
      openAcceptShiftDrawer,
      modalVisible: profileRequirements.modalVisible,
      modalMissing: profileRequirements.modalMissing,
      goToRequirement: profileRequirements.goToRequirement,
      SelectAllShifts,
      isAustralia,
      distanceInMiles,
      message,
      isUS,
      buttonLabel,
      calculateTravelCompensation,
      shouldDisplay,
      pendingDocumentBanner,
      pendingDocumentBannerSuccess,
      pendingDocumentBannerMessage,
      pendingDocumentList,
      showDocReviewModal,
      selectedDocForReview,
      isAcknowledgingDoc,
      areAllRequiredDocsAccepted,
      handleDocItemClick,
      confirmAcknowledgeDoc,
      isImageDoc,
      isPdfDoc,
      downloadDoc,
      isDownloadingDoc,
      assignAcceptanceTrackingId,
    };
  },
};
</script>

<style scoped>
.premium-error-banner {
  display: flex;
  align-items: center;
  gap: 12px;
  background-color: #fef2f2;
  border: 1px solid #fee2e2;
  border-radius: 8px;
  padding: 12px 16px;
  margin: 0 0 16px 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}
.premium-error-banner .premium-banner__icon {
  color: #ef4444;
  font-size: 20px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.premium-error-banner .premium-banner__text {
  color: #991b1b;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
  text-align: left;
}

.premium-success-banner {
  display: flex;
  align-items: center;
  gap: 12px;
  background-color: #f0fdf4;
  border: 1px solid #dcfce7;
  border-radius: 8px;
  padding: 12px 16px;
  margin: 0 0 16px 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}
.premium-success-banner .premium-banner__icon {
  color: #16a34a;
  font-size: 20px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.premium-success-banner .premium-banner__text {
  color: #166534;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
  text-align: left;
}
.pending-banner-fade-enter-active,
.pending-banner-fade-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.pending-banner-fade-enter-from,
.pending-banner-fade-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

/* Onboarding Documents Checklist Styles */
.pending-documents-card {
  background: #f8fafc;
  border: 1.5px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 18px;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.04);
}

.pending-documents-header {
  margin-bottom: 12px;
  text-align: left;
}

.pending-documents-title {
  font-size: 15px;
  font-weight: 700;
  color: #1e293b;
  display: flex;
  align-items: center;
  gap: 6px;
}

.pending-documents-subtitle {
  font-size: 12.5px;
  color: #64748b;
  margin-top: 3px;
  line-height: 1.35;
}

.pending-documents-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.pending-doc-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 12px 14px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  user-select: none;
}

.pending-doc-item:hover {
  border-color: #3b82f6;
  box-shadow: 0 3px 8px rgba(59, 130, 246, 0.12);
  transform: translateY(-1px);
}

.pending-doc-item.is-acknowledged {
  background: #f0fdf4;
  border-color: #86efac;
}

.pending-doc-checkbox-wrapper {
  margin-top: 2px;
  display: flex;
  align-items: center;
}

.pending-documents-card .el-checkbox,
.pending-doc-checkbox-wrapper .el-checkbox {
  display: inline-flex !important;
  align-items: center !important;
  border: none !important;
  border-radius: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  position: static !important;
  height: auto !important;
  width: auto !important;
  background: transparent !important;
}

.pending-documents-card .el-checkbox .el-checkbox__input,
.pending-doc-checkbox-wrapper .el-checkbox .el-checkbox__input {
  display: inline-flex !important;
  position: static !important;
  align-items: center !important;
  justify-content: center !important;
}

.pending-documents-card .el-checkbox .el-checkbox__inner,
.pending-doc-checkbox-wrapper .el-checkbox .el-checkbox__inner {
  width: 18px !important;
  height: 18px !important;
  border-radius: 4px !important;
  margin-top: 0 !important;
  border: 1.5px solid #cbd5e1 !important;
  background-color: #ffffff !important;
  transition: all 0.15s ease-in-out !important;
}

.pending-documents-card .el-checkbox:hover .el-checkbox__inner,
.pending-doc-checkbox-wrapper .el-checkbox:hover .el-checkbox__inner {
  border-color: #3b82f6 !important;
}

.pending-documents-card .el-checkbox.is-checked .el-checkbox__inner,
.pending-doc-checkbox-wrapper .el-checkbox.is-checked .el-checkbox__inner,
.pending-documents-card .el-checkbox.is-disabled.is-checked .el-checkbox__inner,
.pending-doc-checkbox-wrapper .el-checkbox.is-disabled.is-checked .el-checkbox__inner {
  background-color: #22c55e !important;
  border-color: #22c55e !important;
}

.pending-documents-card .el-checkbox .el-checkbox__inner::after,
.pending-doc-checkbox-wrapper .el-checkbox .el-checkbox__inner::after,
.pending-documents-card .el-checkbox.is-disabled .el-checkbox__inner::after,
.pending-doc-checkbox-wrapper .el-checkbox.is-disabled .el-checkbox__inner::after {
  border-color: #ffffff !important;
  height: 9px !important;
  width: 4px !important;
  left: 5px !important;
  top: 1px !important;
}

.pending-documents-card .el-checkbox .el-checkbox__label,
.pending-doc-checkbox-wrapper .el-checkbox .el-checkbox__label {
  display: none !important;
  padding-left: 0 !important;
  width: auto !important;
}

.pending-doc-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
  text-align: left;
}

.pending-doc-name-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.pending-doc-name {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
}

.doc-badge-required {
  background: #fee2e2;
  color: #dc2626;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 9999px;
  letter-spacing: 0.2px;
}

.doc-badge-accepted {
  background: #dcfce7;
  color: #16a34a;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 9999px;
  display: inline-flex;
  align-items: center;
  gap: 3px;
}

.pending-doc-action-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
}

.doc-action-hint {
  font-size: 12px;
  color: #3b82f6;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.doc-preview-link {
  font-size: 12px;
  color: #2563eb;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  text-decoration: underline;
  cursor: pointer;
}

.doc-preview-link:hover {
  color: #1d4ed8;
}

/* Document Review Modal Dialog Styles */
:deep(.doc-review-dialog) {
  border-radius: 16px;
  overflow: hidden;
  max-width: 680px;
}

.doc-modal-content {
  text-align: left;
}

.doc-modal-header-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e2e8f0;
  margin-bottom: 14px;
}

.doc-modal-title-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.doc-modal-doc-title {
  font-size: 17px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  display: flex;
  align-items: center;
}

.doc-modal-actions-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.btn-modal-action {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  font-size: 12.5px;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
}

.btn-modal-action.btn-open {
  background: #eff6ff;
  color: #2563eb;
  border: 1px solid #bfdbfe;
}

.btn-modal-action.btn-open:hover {
  background: #dbeafe;
  color: #1d4ed8;
}

.btn-modal-action.btn-download {
  background: #f0fdf4;
  color: #16a34a;
  border: 1px solid #bbf7d0;
}

.btn-modal-action.btn-download:hover:not(:disabled) {
  background: #dcfce7;
  color: #15803d;
}

.btn-modal-action.btn-download:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Document Inline Preview */
.doc-inline-preview-wrapper {
  margin: 12px 0;
}

.doc-preview-container {
  width: 100%;
  border-radius: 10px;
  background: #f8fafc;
  border: 1.5px solid #cbd5e1;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.doc-preview-image-box {
  max-height: 440px;
  padding: 12px;
  background: #0f172a;
}

.doc-preview-image {
  max-width: 100%;
  max-height: 410px;
  object-fit: contain;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
}

.doc-preview-frame-box {
  height: 420px;
}

.doc-preview-iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.doc-modal-acknowledgement-box {
  background: #f8fafc;
  border: 1px dashed #94a3b8;
  border-radius: 8px;
  padding: 12px;
  margin-top: 14px;
}

.ack-note {
  font-size: 12px;
  color: #334155;
  line-height: 1.4;
}

.flex-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>

